import MainApiEnum from "../Enums/EnumMainApi";

export const GET_PROFILE_SUMMARY_FIELDS_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.GET_SUMMARY_FIELDS
export const GET_LEADERS_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.GET_LEADERS
export const GAME_ROOM_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.CREATE_GAME_ROOM
export const DELETE_GAME_ROOM_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.DElETE_GAME_ROOM
export const GAME_ROOM_VERSUS_FRIEND_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.CREATE_GAME_ROOM_VERSUS_FRIEND
export const GET_FRIEND_LEADERS_API_URL = process.env.REACT_APP_API_URL + MainApiEnum.GET_FRIEND_LEADERS